module.exports = __webpack_public_path__ + "media/images/trash-2-2cef1ed91ceb2c7ec44711026f230c48.svg";